var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "ItpPage",
    {
      attrs: {
        size: _vm.size,
        header: _vm.documentTitle,
        loaded: _vm.loaded,
        noShow: !_vm.loaded,
        modal: _vm.modal,
        "itp-cname": "WorkSummaryView",
        modalBindings: _vm.b_7315092382398562_modalBindings
      },
      on: {
        close: function($event) {
          return _vm.evh_7315092382398562_close($event, {})
        }
      }
    },
    [
      _vm.loaded
        ? _c(
            "VueSlickgrid",
            {
              ref: "grid",
              staticClass: "page--grid",
              attrs: {
                name: "workSummary",
                headerTitle: _vm._f("pgettext")(
                  "Work summary",
                  "WorkSummaryView"
                ),
                items: _vm.$fn.slickDataSource(
                  "query_worksheets_work_summary",
                  {
                    parameters: function() {
                      return _vm.params
                    },
                    assignUniqueId: true
                  }
                ),
                "checkbox-row-selection": "",
                "footer-totals": "",
                "header-show-column-selector-button": "",
                headerShowReloadButton:
                  _vm.b_2248226175642056_headerShowReloadButton,
                "export-to-csv": "",
                exportToCsvFilename: _vm._f("pgettext")(
                  "work-summary",
                  "ExportFilename"
                ),
                columnDefaults: _vm.b_2248226175642056_columnDefaults,
                columns: _vm.b_2248226175642056_columns
              },
              on: {
                selectedRowsChanged: function($event) {
                  return _vm.evh_2248226175642056_selectedRowsChanged(
                    $event,
                    {}
                  )
                },
                command: function($event) {
                  return _vm.evh_2248226175642056_command($event, {})
                }
              }
            },
            [
              _c(
                "DIV",
                {
                  staticClass: "flex-grow-1 d-flex",
                  attrs: { slot: "toolbar" },
                  slot: "toolbar"
                },
                [
                  _c("DateRangeSelector", {
                    staticClass: "mr-2",
                    style: _vm.b_6466705138206980_style,
                    attrs: {
                      name: "paymentFilters",
                      from: _vm.params.date_from,
                      to: _vm.params.date_to
                    },
                    on: {
                      changed: function($event) {
                        return _vm.evh_6466705138206980_changed($event, {})
                      }
                    }
                  }),
                  _vm._v(" "),
                  _c(
                    "DIV",
                    [
                      _c("ItpButton", {
                        attrs: {
                          variant: "light",
                          icon: _vm.$config.reloadIcon,
                          title: _vm._f("pgettext")(
                            "Load data",
                            "WorkSummaryViewFilters"
                          ),
                          spinning:
                            _vm.actions &&
                            _vm.actions.load &&
                            _vm.actions.load.isRunning
                        },
                        on: {
                          click: function($event) {
                            $event.preventDefault()
                            $event.stopPropagation()
                            return _vm.evh_4440454779651433_clickPreventStop(
                              $event,
                              {}
                            )
                          }
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.loaded ? _c("template", { slot: "footer" }) : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }